import { useTableContext } from '@core/table/features/TableContext';

import getTableHeadCss from './styles/getTableHeadCss';
import TableHeadCell from './TableHeadCell';

const TableHead = () => {
  const { columns, status } = useTableContext();

  return (
    <thead
      css={getTableHeadCss}
      data-testid="thead"
      // @ts-expect-error Current version of react doesn't have inert added to its type definitions.
      inert={status === 'progressing' ? 'true' : undefined}
    >
      <tr role="row">
        {columns.map(
          /* eslint-disable @typescript-eslint/no-unused-vars */
          ({ accessor, renderCell, sortComparator, ...restColumnProps }) => (
            <TableHeadCell
              {...{ ...restColumnProps, accessor }}
              key={accessor}
            />
          )
        )}
      </tr>
    </thead>
  );
};

export default TableHead;
